import React from "react";
import Captcha from "react-numeric-captcha";
import { useState, useEffect, useContext, useRef } from "react";
import { DrtContext } from "../../../../../context/DrtContext";

import { Modal, Table, Button } from "react-bootstrap";
import { apiStagingOutdoorUrl } from "../../../../../constants";

import axios from "axios";
import { useFormik } from "formik";

const PartyJudgeName = () => {
  const [loading, setLoading] = useState(false);

  const [captchaStatus, setCaptchaStatus] = useState(false);
  const capt = useRef();

  // state to control Model
  const [isOpenModal, setIsOpenModal] = useState(false);
  // state for first dropDownData
  const [dratLocations, setDratLocations] = useState([]);
  //state for second dropDownData
  const [drtLocation, setDrtLocation] = useState([]);
  // states for Date
  const refFromDate = useRef("");
  const refToDate = useRef("");

  // fetching first dropDownData (All Locations)
  const fetchDratDrtLocation = async () => {
    const res = await axios.post(
      `${apiStagingOutdoorUrl}/getDrtDratScheamName`
    );
    const sortedLocation = res.data.sort((a, b) =>
      a.SchemaName > b.SchemaName ? 1 : b.SchemaName > a.SchemaName ? -1 : 0
    );
    setDratLocations(sortedLocation);
  };

  // get final data after sending required payload
  const [caseDetail, setCaseDetail] = useState([]);
  const [error, setError] = useState(false);
  const fetchCaseDetail = async (url, data) => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.post(
        `${apiStagingOutdoorUrl}/${url}`,
        data,
        config
      );
      setCaseDetail(response.data);
    } catch (error) {
      console.log(error);
      setCaseDetail([]);
      setLoading(false);
      setError(true);
    }
    setLoading(false);
  };

  // calling function for first dropDown data
  useEffect(() => {
    fetchDratDrtLocation();
  }, []);

  const initialValues = {
    schemeNameDratDrtId: "",
    dratDailyFinalOrderId: "",
    fromDate: "",
    toDate: "",
  };

  const validate = (values) => {
    let errors = {};
    if (!values.schemeNameDratDrtId) {
      errors.schemeNameDratDrtId = "Required";
    }
    if (!values.dratDailyFinalOrderId) {
      errors.dratDailyFinalOrderId = "Required";
    }
    if (!values.fromDate) {
      errors.fromDate = "Required";
    }
    if (!values.toDate) {
      errors.toDate = "Required";
    }

    return errors;
  };

  const onSubmit = (values, { resetForm }) => {
    console.log("values are ", values);

    const caseDetailData = {
      schemeNameDrtId: values.schemeNameDratDrtId,
      dratDailyFinalOrderId: values.dratDailyFinalOrderId,
      fromDate: refFromDate.current,
      toDate: refToDate.current,
    };

    fetchCaseDetail("getDratOrderJudgementReportFromToDate", caseDetailData);
    setTimeout(() => {
      setIsOpenModal(true);
    }, 1000);

    setCaptchaStatus(false);
    // resetForm();
    capt.current.refresh();
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validate,
  });

  const locationAndDate = (value, name) => {
    if (name === "fromDate") {
      let newDate = value.split("-").reverse().join("/");
      refFromDate.current = newDate;
    }
    if (name === "toDate") {
      let newDate = value.split("-").reverse().join("/");
      refToDate.current = newDate;
    }
    console.log(name, value);
  };

  const doubleDigitDate = (date) => {
    // let date = "25/8/2022"
    if (date) {
      let arr = date.split("/");
      if (arr[0].length === 1) arr[0] = "0" + arr[0];
      if (arr[1].length === 1) arr[1] = "0" + arr[1];

      return arr.join("/");
    }
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="w-100">
        <div className="form-row row">
          {/* field 1 */}
          <div className="form-group col-md-4">
            <label className="mandatory" htmlFor="staticEmail">
              {" "}
              DRAT
            </label>

            <select
              className="form-control"
              placeholder=""
              type="text"
              id="schemeNameDratDrtId"
              name="schemeNameDratDrtId"
              onChange={(e) => {
                formik.handleChange(e);
                // fetchDrtLocation(e.target.value)
              }}
              value={formik.values.schemeNameDratDrtId}
              onBlur={formik.handleBlur}
            >
              <option>Select DRAT Location</option>
              {dratLocations
                .filter((i) => i.schemeNameDrtId > 99)
                .map((item, index) => (
                  <option value={`${item.schemeNameDrtId}`} key={index}>
                    {item.SchemaName}
                  </option>
                ))}
            </select>
            {formik.touched.schemeNameDratDrtId &&
            formik.errors.schemeNameDratDrtId ? (
              <div className="error">{formik.errors.schemeNameDratDrtId}</div>
            ) : null}
          </div>

          {/* field 2 */}
          <div className="form-group col-md-4">
            <label className="mandatory" htmlFor="">
              {" "}
              Daily/Final Order
            </label>

            <select
              id="dratDailyFinalOrderId"
              name="dratDailyFinalOrderId"
              type="select"
              className="form-control"
              placeholder=""
              onChange={formik.handleChange}
              value={formik.values.dratDailyFinalOrderId}
              onBlur={formik.handleBlur}
            >
              <option>Select Daily/Final Order</option>
              <option value="1"> Daily Order </option>
              <option value="2"> Final Order </option>
            </select>
            {formik.touched.dratDailyFinalOrderId &&
            formik.errors.dratDailyFinalOrderId ? (
              <div className="error">{formik.errors.dratDailyFinalOrderId}</div>
            ) : null}
          </div>

          {/* Field 3 */}
          <div className="form-group col-md-4">
            <label className="mandatory" htmlFor="inputEmail4">
              From Date
            </label>
            <input
              className="form-control"
              placeholder=""
              type="date"
              id="fromDate"
              name="fromDate"
              onChange={(e) => {
                formik.handleChange(e);
                locationAndDate(e.target.value, e.target.name);
              }}
              value={formik.values.fromDate}
              onBlur={formik.handleBlur}
              autoComplete="off"
            />
            {formik.touched.fromDate && formik.errors.fromDate ? (
              <div className="error">{formik.errors.fromDate}</div>
            ) : null}
          </div>

          {/* Field 4 */}
          <div className="form-group col-md-4">
            <label className="mandatory" htmlFor="inputEmail4">
              To Date
            </label>
            <input
              className="form-control"
              placeholder=""
              type="date"
              id="toDate"
              name="toDate"
              onChange={(e) => {
                formik.handleChange(e);
                locationAndDate(e.target.value, e.target.name);
              }}
              value={formik.values.toDate}
              onBlur={formik.handleBlur}
            />
            {formik.touched.toDate && formik.errors.toDate ? (
              <div className="error">{formik.errors.toDate}</div>
            ) : null}
          </div>

          {/* field Captcha */}

          <div className="form-group col-md-8 main-menu-captcha capcha-sec">
            <label>Captcha</label>
            <div className="col-sm-12 px-0 d-flex">
              <Captcha
                onChange={(status) => {
                  setCaptchaStatus(status);
                }}
                ref={capt}
                required
              />
              <br />
              <button
                type="submit"
                disabled={!captchaStatus}
                className="btn btn-reload"
              >
                <i className="fas fa-search">
                  <span className="sr-only">no text</span>
                </i>
              </button>
            </div>
            {!captchaStatus ? (
              <div className="captcha-text">Enter valid captcha</div>
            ) : null}
          </div>
        </div>
      </form>

      {loading ? (
        <h6 className="loader">Loading ......</h6>
      ) : (
        <Modal
          show={isOpenModal}
          onHide={() => setIsOpenModal(false)}
          // className="modal-90w"
        >
           <Modal.Header className="d-flex justify-content-between align-items-start">
            DRAT ORDER/JUDGEMENT REPORT
            <Button
              type="button"
              className="close"
              onClick={() => setIsOpenModal(false)}
            >
              &times;
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>
                      <center>Applicant V/S Respondent</center>
                    </th>
                    <th>Dairy No.</th>
                    <th>Application No.</th>
                    <th>Date of Order</th>
                    <th>Pronounced By</th>
                    <th>View Daily Order(s)</th>
                  </tr>
                </thead>
                {!error && caseDetail && caseDetail.length > 0 ? (
                  <tbody>
                    {caseDetail.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <center>
                            {item.applicantName} <br />
                            vs
                            <br />
                            {item.respondentName}
                          </center>
                        </td>
                        <td>{item.diaryno}</td>
                        <td>{item.applicantno}</td>
                        <td>{doubleDigitDate(item.dateoffiling)}</td>
                        <td>{item.pronouncedBy}</td>
                        <td>
                          <a target="_blank" href={`${item.dailyOrderPdf}`}>
                            <i className="fas fa-search">
                              <span className="sr-only">no text</span>
                            </i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <>
                    <tbody>
                      <tr>
                        <td colSpan={"9"}> No Record Found </td>
                      </tr>
                    </tbody>
                  </>
                )}
              </Table>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PartyJudgeName;
